import validate from 'lib/utils/validationRules';

const getReportType = (state) => state.reportType;

const getReportTemplateList = (state) => state.reportTemplateList;

const isEmptyReportTemplateList = (state) => validate.isEmptyArray(state.reportTemplateList);

const getCurrentEditingTemplate = (state) => state.currentEditingTemplate;

export default {
  getReportType,
  getReportTemplateList,
  isEmptyReportTemplateList,
  getCurrentEditingTemplate,
};
